import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import hu from "./locales/hu.json";
import sk from "./locales/sk.json";
import en from "./locales/en.json";

const LEGACY_STORAGE_KEY = "app_locale";
const LANGS = ["hu", "sk", "en"] as const;

function browserDefaultLocale(): (typeof LANGS)[number] {
  if (typeof window === "undefined") return "hu";
  const nav = navigator.language || (navigator as { userLanguage?: string }).userLanguage || "";
  return nav.startsWith("sk") ? "sk" : nav.startsWith("en") ? "en" : "hu";
}

// Initial language only from browser (in-memory). Logged-in users get `preferences.locale` from the API (ThemeProvider / LocaleSyncFromUser).
const appLocaleDetector = {
  name: "appLocale" as const,
  lookup(): string {
    if (typeof window === "undefined") return "hu";
    try {
      localStorage.removeItem(LEGACY_STORAGE_KEY);
    } catch {
      // ignore
    }
    return browserDefaultLocale();
  },
  cacheUserLanguage(): void {
    // Do not persist locale locally — user preference lives in DB (`users.preferences.locale`).
  },
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector(appLocaleDetector);

i18n
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    resources: { hu: { translation: hu }, sk: { translation: sk }, en: { translation: en } },
    fallbackLng: "hu",
    supportedLngs: [...LANGS],
    detection: {
      order: ["appLocale"],
      caches: [],
    },
    interpolation: { escapeValue: false },
  });

// Keep document lang in sync for date inputs, etc.
i18n.on("languageChanged", (lng) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = lng;
  }
});
// Set initial lang
if (typeof document !== "undefined") {
  document.documentElement.lang = i18n.language;
}

export default i18n;
